import { ChangeEventHandler, FocusEventHandler, useState } from "react";
import { BYInput } from "./BYInput";
import { FormikErrors, FormikTouched } from "formik";

interface BYPasswordInputProps {
  value: string;
  onBlur?: FocusEventHandler<string> | undefined;
  onChange?: ChangeEventHandler<string> | undefined;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  name?: string;
  title?: string;
  autoComplete?: string;
  required?: boolean;
}

export const BYPasswordInput = ({
  value,
  onBlur,
  onChange,
  touched,
  error,
  name,
  title,
  autoComplete,
  required,
}: BYPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
    
  return (
    <div className="password-input-container">
      <BYInput
        type={showPassword ? "text" : "password"}
        name={name || "password"}
        className="form-control"
        title={title || "Mot de passe"}
        value={value}
        autoComplete={autoComplete}
        onBlur={onBlur}
        onChange={onChange}
        required={required}
        touched={touched}
        error={error}
      />
      <button
        className="btn btn-link btn-sm show-password-button shadow-none"
        tabIndex={-1}
        type="button"
        onClick={() => setShowPassword(!showPassword)}
      >
        <i className={`fa ${showPassword ? "fa fa-eye" : "fa fa-eye-slash"}`}></i>
      </button>
    </div>
  );
};
